import React from 'react';

import { makeStyles, blend } from '@gogame/ui/styles';

const useStyles = makeStyles(
  (theme) => ({
    root: {
      height: '100%',
      overflow: 'auto',
      position: 'relative',
      '&::-webkit-scrollbar': {
        borderLeft: '1px solid rgba(0, 0, 0, 0.12)',
      },
    },
  }),
  { name: 'ListScrollContainer' }
);

const ScrollContainer = React.forwardRef(({ children, ...props }, ref) => {
  const classes = useStyles();
  return (
    <div ref={ref} className={classes.root} {...props}>
      {children}
    </div>
  );
});

export default ScrollContainer;
